import { createAsyncThunk } from "@reduxjs/toolkit";

import { apiClient } from "@/config/api";
import {
  CompleteTaskBody,
  CreateTaskBody,
  GetTasksBody,
} from "@/api/task/types";
import { handleApiError } from "@/utils/functions";

export const getTasks = createAsyncThunk(
  "task/getTasks",
  async ({ completed, page }: GetTasksBody, { rejectWithValue }) => {
    try {
      const response = await apiClient.get("/tasks", {
        params: { page, completed },
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(handleApiError(error, "Get tasks failed"));
    }
  }
);

export const completeTask = createAsyncThunk(
  "task/completeTask",
  async ({ id, completed }: CompleteTaskBody, { rejectWithValue }) => {
    try {
      const response = await apiClient.patch(`/tasks/${id}/complete`, {
        completed,
      });

      return response.data.data;
    } catch (error) {
      return rejectWithValue(handleApiError(error, "Complete task failed"));
    }
  }
);

export const createTask = createAsyncThunk(
  "task/createTask",
  async (
    { title, category, dateTo, dateFrom }: CreateTaskBody,
    { rejectWithValue }
  ) => {
    try {
      const response = await apiClient.post(`/tasks`, {
        title,
        category,
        dateTo: dateTo ?? "",
        dateFrom: dateFrom ?? "",
      });

      return response.data.data;
    } catch (error) {
      return rejectWithValue(handleApiError(error, "Create task failed"));
    }
  }
);
